export default [
  {
    "id": "0",
    "d": "M15.9,739.3h97.8c7.8,0,14.2-6.3,14.2-14.2V393.5c0-7.8-6.3-14.2-14.2-14.2H15.9 c-7.8,0-14.2,6.3-14.2,14.2v331.6h0.1c0,7.8,6.3,14.2,14.2,14.2"
  },
  {
    "id": "1",
    "d": "M88,361.3h97.8c7.8,0,14.2-6.3,14.2-14.2V15.5c0-7.8-6.3-14.2-14.2-14.2H88 c-7.8,0-14.2,6.3-14.2,14.2v331.6C73.8,354.9,80.1,361.3,88,361.3"
  },
  {
    "id": "2",
    "d": "M272,725.1V393.5c0-7.8-6.3-14.2-14.2-14.2h0.1h-97.8c-7.8,0-14.2,6.3-14.2,14.2v331.6 c0,7.8,6.3,14.2,14.2,14.2h97.8c7.8,0,14.2-6.3,14.2-14.2"
  },
  {
    "id": "3",
    "d": "M217.9,15.5c0-7.8,6.4-14.2,14.2-14.2h97.8c7.9,0,14.2,6.4,14.2,14.2v331.6 c0,7.9-6.4,14.2-14.2,14.2h-97.8h0.1c-7.9,0-14.2-6.4-14.2-14.2L217.9,15.5"
  },
  {
    "id": "4",
    "d": "M402,379.3h-97.8c-7.8,0-14.2,6.4-14.2,14.2v331.6c0,7.8,6.3,14.2,14.2,14.2H402 c7.8,0,14.2-6.3,14.2-14.2V393.5C416.2,385.7,409.9,379.3,402,379.3z"
  },
  {
    "id": "5",
    "d": "M488.3,347.2c0,7.8-6.4,14.1-14.2,14.1h-97.8c-7.9,0-14.2-6.4-14.2-14.2V15.5 c0-7.8,6.4-14.2,14.2-14.2h97.8c7.9,0,14.2,6.4,14.2,14.2h-0.1v331.6"
  },
  {
    "id": "6",
    "d": "M448.3,739.3h97.8c7.8,0,14.2-6.3,14.2-14.2V393.5c0-7.8-6.3-14.2-14.2-14.2h-97.8h0.1 c-7.8,0-14.2,6.3-14.2,14.2v331.6c0,7.8,6.3,14.2,14.2,14.2"
  },
  {
    "id": "7",
    "d": "M618.3,361.3c7.8,0,14.2-6.3,14.2-14.2h-0.1V15.5c0-7.8-6.3-14.2-14.1-14.2h-0.1h-97.8 c-7.8,0-14.2,6.4-14.2,14.2v331.6h0.1c0,7.8,6.3,14.2,14.2,14.2h-0.1H618.3"
  },
  {
    "id": "8",
    "d": "M690.3,379.3h-97.8c-7.8,0-14.2,6.3-14.2,14.2v331.6c0,7.8,6.3,14.2,14.2,14.2h97.8 c7.8,0,14.2-6.3,14.2-14.2V393.5C704.5,385.7,698.2,379.3,690.3,379.3z"
  },
  {
    "id": "9",
    "d": "M762.4,1.3h-97.8c-7.8,0-14.2,6.3-14.2,14.2v331.6c0,7.8,6.3,14.2,14.2,14.2h97.8 c7.8,0,14.2-6.3,14.2-14.2h-0.1V15.5C776.5,7.7,770.2,1.3,762.4,1.3"
  },
  {
    "id": "10",
    "d": "M736.6,739.3h97.8c7.8,0,14.2-6.3,14.2-14.2V393.5c0-7.8-6.3-14.2-14.2-14.2h-97.8 c-7.8,0-14.2,6.3-14.2,14.2h0.1v331.6C722.5,732.9,728.8,739.3,736.6,739.3"
  },
  {
    "id": "11",
    "d": "M794.5,15.5v331.6c0,7.8,6.3,14.2,14.2,14.2h97.8c7.8,0,14.2-6.3,14.2-14.2V15.5 c0-7.8-6.3-14.2-14.2-14.2h-97.8C800.9,1.3,794.5,7.6,794.5,15.5z"
  },
  {
    "id": "12",
    "d": "M992.7,725.1V393.5c0-7.8-6.3-14.2-14.2-14.2h0.1h-97.8c-7.8,0-14.2,6.3-14.2,14.2v331.6 c0,7.8,6.3,14.2,14.2,14.2h97.8C986.4,739.3,992.8,733,992.7,725.1"
  },
  {
    "id": "13",
    "d": "M938.6,15.5c0-7.9,6.4-14.2,14.2-14.2h97.8c7.9,0,14.2,6.4,14.2,14.2v331.6 c0,7.9-6.4,14.2-14.2,14.2h-97.8h0.1c-7.9,0-14.2-6.4-14.2-14.2L938.6,15.5"
  },
  {
    "id": "14",
    "d": "M1136.9,725.1V393.5c0-7.8-6.3-14.2-14.2-14.2h-97.8c-7.8,0-14.2,6.3-14.2,14.2v331.6 c0,7.8,6.3,14.2,14.2,14.2h97.8C1130.5,739.3,1136.9,733,1136.9,725.1"
  },
  {
    "id": "15",
    "d": "M1209,347.1V15.5c0-7.8-6.3-14.2-14.2-14.2H1097c-7.8,0-14.2,6.4-14.2,14.2v331.6 c0,7.8,6.3,14.2,14.2,14.2h97.8c7.8,0,14.2-6.3,14.2-14.1V347.1z"
  },
  {
    "id": "16",
    "d": "M1281.1,725.2c0,7.8-6.4,14.1-14.2,14.1h-97.8c-7.9,0-14.2-6.4-14.2-14.2V393.5 c0-7.8,6.4-14.2,14.2-14.2h97.8h-0.1c7.9,0,14.2,6.4,14.2,14.2L1281.1,725.2"
  },
  {
    "id": "17",
    "d": "M1353.1,347.1V15.5c0-7.8-6.3-14.2-14.2-14.2h-97.8c-7.8,0-14.2,6.3-14.2,14.2h0.1v331.6 c0,7.8,6.3,14.2,14.2,14.2h-0.1h97.8c7.8,0,14.2-6.3,14.2-14.1"
  },
  {
    "id": "18",
    "d": "M1425.2,725.1V393.5c0-7.8-6.3-14.2-14.2-14.2h-97.8c-7.8,0-14.2,6.3-14.2,14.2v331.6 c0,7.8,6.3,14.2,14.2,14.2h97.8C1418.8,739.3,1425.2,733,1425.2,725.1"
  },
  {
    "id": "19",
    "d": "M1497.3,347.2c0,7.8-6.4,14.1-14.2,14.1h-97.8c-7.9,0-14.2-6.4-14.2-14.2V15.5 c0-7.9,6.4-14.2,14.2-14.2h97.8c7.9,0,14.2,6.4,14.2,14.2h-0.1v331.6"
  },
  {
    "id": "20",
    "d": "M1457.3,739.3h97.8c7.8,0,14.2-6.3,14.2-14.2V393.5c0-7.8-6.3-14.2-14.2-14.2h-97.8 c-7.8,0-14.2,6.3-14.2,14.2h0.1v331.6C1443.2,732.9,1449.5,739.3,1457.3,739.3"
  },
  {
    "id": "21",
    "d": "M1515.2,347.1V15.5c0-7.8,6.4-14.2,14.2-14.2h97.8c7.9,0,14.2,6.4,14.2,14.2v331.6 c0,7.9-6.4,14.2-14.2,14.2h-97.8h0.1C1521.6,361.3,1515.3,354.9,1515.2,347.1"
  },
  {
    "id": "22",
    "d": "M1713.4,725.1V393.5h0.1c0-7.8-6.3-14.2-14.2-14.2h-97.8c-7.8,0-14.2,6.3-14.2,14.2v331.6 c0,7.8,6.3,14.2,14.2,14.2h97.8C1707.1,739.3,1713.5,733,1713.4,725.1"
  },
  {
    "id": "23",
    "d": "M1673.5,1.3h97.8c7.9,0,14.2,6.4,14.2,14.2v331.6h0.1c0,7.9-6.4,14.2-14.2,14.2h-97.8 c-7.9,0-14.2-6.4-14.2-14.2V15.5C1659.4,7.6,1665.8,1.3,1673.5,1.3"
  },
  {
    "id": "24",
    "d": "M1731.5,725.1c0,7.8,6.3,14.2,14.1,14.2h97.8c7.8,0,14.2-6.3,14.2-14.2V393.5 c0-7.8-6.3-14.2-14.2-14.2h-97.8c-7.8,0-14.2,6.3-14.2,14.2L1731.5,725.1"
  },
  {
    "id": "25",
    "d": "M1817.7,361.3h97.8c7.8,0,14.2-6.3,14.2-14.2V15.5c0-7.8-6.3-14.2-14.2-14.2h-97.8 c-7.8,0-14.2,6.3-14.2,14.2v331.6C1803.5,354.9,1809.8,361.3,1817.7,361.3"
  },
  {
    "id": "26",
    "d": "M2001.7,725.1V393.5c0-7.8-6.3-14.2-14.2-14.2h0.1h-97.8c-7.8,0-14.2,6.4-14.2,14.2v331.6 c0,7.8,6.3,14.2,14.2,14.2h97.8C1995.4,739.3,2001.8,733,2001.7,725.1"
  },
  {
    "id": "27",
    "d": "M1947.6,15.5c0-7.8,6.4-14.2,14.2-14.2h97.8c7.9,0,14.2,6.4,14.2,14.2v331.6 c0,7.9-6.4,14.2-14.2,14.2h-97.8h0.1c-7.9,0-14.2-6.4-14.2-14.2L1947.6,15.5"
  },
  {
    "id": "28",
    "d": "M2131.7,379.3h-97.8c-7.8,0-14.2,6.4-14.2,14.2v331.6c0,7.8,6.3,14.2,14.2,14.2h97.8 c7.8,0,14.2-6.3,14.2-14.2V393.5C2145.9,385.7,2139.6,379.3,2131.7,379.3z"
  },
  {
    "id": "29",
    "d": "M2203.8,1.3H2106c-7.8,0-14.2,6.3-14.2,14.2v331.6c0,7.8,6.3,14.2,14.2,14.2h97.8 c7.8,0,14.2-6.3,14.2-14.2h-0.1V15.5C2217.9,7.7,2211.6,1.3,2203.8,1.3"
  },
  {
    "id": "30",
    "d": "M2178,739.3h97.8c7.8,0,14.2-6.3,14.2-14.2V393.5c0-7.8-6.3-14.2-14.2-14.2H2178h0.1 c-7.8,0-14.2,6.3-14.2,14.2v331.6c0,7.8,6.3,14.2,14.2,14.2"
  },
  {
    "id": "31",
    "d": "M2235.9,15.5v331.6c0,7.8,6.3,14.2,14.2,14.2h97.8c7.8,0,14.2-6.3,14.2-14.2V15.5 c0-7.8-6.3-14.2-14.2-14.2h-97.8C2242.3,1.3,2235.9,7.6,2235.9,15.5z"
  },
  {
    "id": "32",
    "d": "M2308,393.5v331.6c0,7.8,6.3,14.2,14.2,14.2h97.8c7.8,0,14.2-6.3,14.2-14.2V393.5 c0-7.8-6.3-14.2-14.2-14.2h-97.8C2314.4,379.3,2308,385.6,2308,393.5z"
  },
  {
    "id": "33",
    "d": "M2506.3,347.2c0,7.8-6.4,14.1-14.2,14.1h-97.8h-0.1c-7.8,0-14.1-6.4-14.1-14.2V15.5 c0-7.9,6.4-14.2,14.2-14.2h97.8c7.9,0,14.2,6.4,14.2,14.2h-0.1v331.6"
  },
  {
    "id": "34",
    "d": "M2578.3,725.1V393.5c0-7.8-6.3-14.2-14.2-14.2h-97.8c-7.8,0-14.2,6.3-14.2,14.2h0.1v331.6 c0,7.8,6.3,14.2,14.1,14.2h97.8C2571.9,739.3,2578.2,732.9,2578.3,725.1"
  },
  {
    "id": "35",
    "d": "M2524.3,15.5c0-7.8,6.3-14.2,14.1-14.2h97.8c7.9,0,14.2,6.4,14.2,14.2v331.6 c0,7.9-6.4,14.2-14.2,14.2h-97.8c-7.8,0-14.1-6.4-14.1-14.2h-0.1V15.5"
  },
  {
    "id": "36",
    "d": "M2596.3,393.4c0-7.8,6.4-14.1,14.2-14.1h97.8h-0.1c7.9,0,14.2,6.4,14.2,14.2v331.6h0.1 c0,7.9-6.4,14.2-14.2,14.2h-97.8h-0.1c-7.8,0-14.1-6.4-14.1-14.2L2596.3,393.4"
  },
  {
    "id": "37",
    "d": "M2668.4,15.5v331.6c0,7.8,6.3,14.2,14.1,14.2h97.8c7.8,0,14.2-6.3,14.2-14.2V15.5 c0-7.8-6.3-14.2-14.2-14.2h-97.8C2674.7,1.3,2668.3,7.6,2668.4,15.5"
  },
  {
    "id": "38",
    "d": "M2852.4,379.3h-97.8c-7.8,0-14.2,6.4-14.2,14.2v331.6c0,7.8,6.3,14.2,14.2,14.2h97.8 c7.8,0,14.2-6.3,14.2-14.2V393.5C2866.6,385.7,2860.3,379.3,2852.4,379.3z"
  },
  {
    "id": "39",
    "d": "M2812.5,15.5v331.6c0,7.8,6.3,14.2,14.2,14.2h97.8c7.8,0,14.2-6.3,14.2-14.2V15.5 c0-7.8-6.3-14.2-14.2-14.2h-97.8C2818.9,1.3,2812.5,7.7,2812.5,15.5z"
  },
  {
    "id": "40",
    "d": "M3010.7,725.1V393.5c0-7.8-6.3-14.2-14.2-14.2h0.1h-97.8c-7.8,0-14.2,6.4-14.2,14.2v331.6 c0,7.8,6.3,14.2,14.2,14.2h97.8c7.8,0,14.2-6.3,14.2-14.2"
  },
  {
    "id": "41",
    "d": "M2956.6,15.5c0-7.9,6.4-14.2,14.2-14.2h97.8c7.9,0,14.2,6.4,14.2,14.2v331.6 c0,7.9-6.4,14.2-14.2,14.2h-97.8h0.1c-7.9,0-14.2-6.4-14.2-14.2L2956.6,15.5"
  },
  {
    "id": "42",
    "d": "M3140.7,379.3h-97.8c-7.8,0-14.2,6.3-14.2,14.2v331.6c0,7.8,6.3,14.2,14.2,14.2h97.8 c7.8,0,14.2-6.3,14.2-14.2V393.5C3154.9,385.7,3148.6,379.3,3140.7,379.3z"
  }
]
